module.exports = __webpack_public_path__ + "static/img/d8ddc445fd360a8882e08de2ba4ea3d.81df93bf.jpg";